import React from 'react';
import { createTableElementClassName } from './tableStyles';

type Props = {
  testId?: string;
};

export const TableWrapper: React.FC<Props> = (props) => {
  const { children, testId } = props;

  const className = createTableElementClassName('wrapper');

  return (
    <table className={className} data-testid={testId}>
      {children}
    </table>
  );
};
